import TemplateContents from './TemplateContents';
import TopHero from './TopHero';
import TopSection1 from './TopSection1';
import TopSection1_5 from './TopSection1_5';
import TopSection2 from './TopSection2';
import TopSection3 from './TopSection3';
import TopSection4 from './TopSection4';
import Curve from './Curve';
import { gsap } from 'gsap';

export default class extends TemplateContents {
  constructor(param) {
    super(param);
  }

  init() {
    super.init();

    // this.hero = new TopHero();
    this.pack.common.addScrollTarget(this);
    this.pack.common.addEnterframeTarget(this);

    this.pack.hero = this.hero = new TopHero();
    this.section1 = new TopSection1();
    this.section1_5 = new TopSection1_5();
    this.section2 = new TopSection2();
    this.section3 = new TopSection3();
    this.section4 = new TopSection4();
    this.pack.curve = this.curve = new Curve();
  }

  reset() {
    super.reset();

    this.setVars();
    this.pack.common.addScrollTarget(this);
    this.pack.common.addEnterframeTarget(this);
  }

  destruct() {
    super.destruct();

    this.pack.common.removeScrollTarget(this);
    this.pack.common.removeEnterframeTarget(this);
    this.section1_5.destruct();
    this.section2.destruct();
    this.section4.destruct();
  }

  setVars() {
    super.setVars();
  }

  setDom() {
    super.setDom();
  }

  initEvents() {
    super.initEvents();
  }

  start() {
    this.hero.start();
    this.section1.start();
    this.section1_5.start();
    this.section2.start();
    this.section3.start();
    this.section4.start();

    gsap.delayedCall(0.8, () => this.scrollToHashAnchor());
  }

  // URLに#new-uniformが付いている場合、.section1_5へアンカースクロールする
  scrollToHashAnchor() {
    if (window.location.hash !== '#new-uniform') return;

    const target = document.querySelector('main.top .section1_5');
    if (!target) return;

    let targetY = target.getBoundingClientRect().top + this.pack.scrollY;
    // PCの場合は少し下まで進める
    if (this.sw >= this.pack.BP) targetY += 300;

    this.pack.anchorScroll(targetY);
  }

  scrollHandler() {
    this.section1.scrollHandler();
    this.section1_5.scrollHandler();
    this.section3.scrollHandler();
    this.section4.scrollHandler();
    this.curve.scrollHandler();
  }

  enterframe() {
    this.curve.enterframe();
    this.section3.enterframe();
  }

  enterframeThinOut() {
    this.hero.enterframeThinOut();
    this.section1.enterframeThinOut();
    this.section1_5.enterframeThinOut();
  }

  executeResize() {
    super.executeResize();
  }
}
